import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Tippy from '../components/ReactTippy';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import Information from '../components/modals/common/Information';
import TableTag from './TableTag';
import AgencyRegistrationApplicationService from '../services/AgencyRegistrationApplications';
import { AGENCY_REGISTRATION_APPLICATION_STATUS } from '../utilities/constants';
import { getAgencyRegistrationApplicationStatus } from '../utilities/constantsUtil';
import { messageUtility } from '../utilities/messageUtility';

export default function AgencyRegistrationApplicationHistoryDialog(props) {
  const { application, moveDetailPage } = props.dialog.state;
  const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [applicationHistory, setApplicationHistory] = useState([]);
  const [displayError, setDisplayError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    'データの読み込みに失敗しました。'
  );
  function fetchData(notify) {
    if (isLoaded) {
      notify();
      setIsLoading(false);
      return;
    }

    const param = {
      company_agent_to: application.id,
      offset: _.size(applicationHistory),
    };
    AgencyRegistrationApplicationService.history(param)
      .then(response => {
        if (response.result) {
          const applications =
            response.data.entities.agency_registration_applications;
          if (_.isEmpty(applications)) {
            setIsLoaded(true);
          } else {
            applications.forEach(history => applicationHistory.push(history));
            setApplicationHistory(applicationHistory);
            setIsLoaded(false);
          }
          setIsLoading(false);
        } else {
          if (response.data.message) {
            setErrorMessage(response.data.message);
          }
          setDisplayError(true);
          setIsLoaded(true);
          setIsLoading(false);
          return;
        }
        if (notify) {
          notify();
          return;
        }
      })
      .catch(error => {
        setDisplayError(true);
        console.log(error);
        setIsLoaded(true);
        setIsLoading(false);
        return;
      });
  }
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className='dialog dialog-md dialog--modal AgencyRegistrationApplications__dialog-table'>
      <div className='dialog-md__header'>
        <span className='dialog__title'>{application.name}の申請履歴一覧</span>
      </div>
      <div className='dialog__body' id='infinityscroll-target-history'>
        <table className='table'>
          <thead className='table__header'>
            <tr className='table__label'>
              <td
                className='value-table value-table--table__label'
                style={{ width: 1, minWidth: 1, paddingRight: 0 }}
              />
              <td className='value-table value-table--table__label'>申請No</td>
              <td className='value-table value-table--table__label'>
                申請作成ユーザー
              </td>
              <td className='value-table value-table--table__label'>
                申請作成日
              </td>
              <td className='value-table value-table--table__label'>
                申請更新日
              </td>
              <td className='value-table value-table--table__label'>
                ステータス
              </td>
            </tr>
          </thead>
          <tbody>
            {applicationHistory.map(item => {
              const formatTime = time => {
                return moment(time).format('YYYY/MM/DD');
              };
              // 最新の申請
              const isLatestApplication =
                application.latest_application_id === item.id;
              // 失効
              const isExpired =
                getAgencyRegistrationApplicationStatus(item.status_no) ===
                AGENCY_REGISTRATION_APPLICATION_STATUS.EXPIRED.TEXT;
              return (
                <tr
                  className={
                    // 最新の申請以外の項目、もしくは失効の項目はグレーアウト
                    !isLatestApplication || isExpired
                      ? 'table__item table__item--old'
                      : 'table__item'
                  }
                  key={`history-item-${item.id}`}
                >
                  <td
                    className='value-table'
                    style={{ width: 1, paddingRight: 8 }}
                  >
                    {application.latest_application_id === item.id && (
                      <TableTag text='最新' />
                    )}
                  </td>
                  <td className='value-table'>{item.id}</td>
                  <td className='value-table'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>
                          {item.create_user_fullname}
                        </div>
                      }
                    >
                      <div className='value-table__company-name'>
                        {item.create_user_fullname
                          ? item.create_user_fullname
                          : '-'}
                      </div>
                    </Tippy>
                  </td>
                  <td className='value-table'>{formatTime(item.created_at)}</td>
                  <td className='value-table'>{formatTime(item.updated_at)}</td>
                  <td className='value-table'>
                    <div className='AgencyRegistrationApplications__status-box'>
                      {getAgencyRegistrationApplicationStatus(item.status_no) ||
                        '-'}
                      <button
                        className='btn btn--contained btn--wide'
                        onClick={() => {
                          moveDetailPage(item.id);
                          props.dialog.callback.close();
                        }}
                      >
                        確認
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <InfinityScrollLoad
          targetId='infinityscroll-target-history'
          total={_.size(applicationHistory)}
          isLoading={isLoading}
          callback={notifyEnd => {
            fetchData(notifyEnd);
          }}
        />
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          className='btn-fixedsize--sub'
          onClick={() => props.dialog.callback.close()}
        >
          閉じる
        </button>
      </div>
      <Information
        visible={displayError}
        onClose={() => {
          setDisplayError(false);
        }}
        title='エラーが発生しました'
        message={errorMessage}
        buttonText={messageUtility.getMessage('I-000-017')}
        multilineText={true}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationHistoryDialog.jsx